require("@rails/ujs").start();
require("bootstrap/dist/js/bootstrap");
require("jquery");
require.context("../images", true);
import "../stylesheets/application";
